<p-fieldset legend="Frontend-Applications" i18n-legend="@@FEUnitFieldsetLabel" class="form-fieldset" [class.valid]="currentFeUnits.length > 0">
  <ul>
    <li *ngFor="let feUnit of allFeUnits">
      <p-checkbox name="feUnits" [(ngModel)]="selectedIds" [value]="feUnit.id" [label]="language === 'de' ? feUnit.de : feUnit.en" (onChange)="changeFeUnit($event, feUnit.id)"></p-checkbox>
    </li>
  </ul>

</p-fieldset>
